/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from "axios";

export const handleUpload = async ({
  dataUpload: data,
  onProgress,
}: {
  dataUpload: any;
  onProgress?: (progress: number) => void;
}) => {
  try {
    const config = {
      headers: {
        "Content-Type": data.mimeType,
      },
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        if (onProgress) onProgress(percentCompleted);
      },
    };

    await axios.put(data.urlUpload, data.file, config).then((res) => {
      setTimeout(() => {
        if (onProgress) onProgress(101);
      }, 2000);
      return res;
    });
  } catch (error) {
    console.error("Upload failed:", error);
    throw error;
  }
};
